import { defineStore } from "pinia";
import { computed, ref, watch } from "vue";
export var useCartStore = defineStore('cartStore', function () {
    var initialized = ref(false);
    var coupons = ref([]);
    var giftsAvailable = ref(0);
    var gifts = ref([]);
    var giftsUsed = computed(function () { return gifts.value.length; });
    var giftsLeft = computed(function () { return giftsAvailable.value - giftsUsed.value; });
    var giftable = ref([]);
    var giftsMinOrderSum = ref(0);
    var giftsVipMinOrderSum = ref(0);
    var products = ref([]);
    var bottles = computed(function () { return products.value.reduce(function (sum, product) {
        return product.category === 'atomizers' ? sum : sum + product.quantity;
    }, 0); });
    var totalSum = ref(0);
    var totalDiscount = ref(0);
    var vipAvailable = computed(function () { return totalSum.value >= giftsVipMinOrderSum.value; });
    watch(vipAvailable, function (value, oldValue) {
        if (!value && oldValue) {
            gifts.value = gifts.value.filter(function (gift) { return !gift.vip; });
        }
    });
    function setCoupons(newCoupons) {
        coupons.value = newCoupons;
    }
    function setProducts(newProducts) {
        products.value = newProducts;
    }
    function getProduct(productId) {
        return products.value.find(function (product) { return product.cartItemId === productId; });
    }
    function removeProduct(cartItemId) {
        if (!products.value.find(function (product) { return product.cartItemId === cartItemId; })) {
            return false;
        }
        products.value = products.value.filter(function (product) { return cartItemId !== product.cartItemId; });
        return true;
    }
    function setTotals(sum, discount) {
        totalSum.value = sum;
        totalDiscount.value = discount;
    }
    function addCoupon(code) {
        if (coupons.value.find(function (coupon) { return code.toLowerCase() === coupon.code.toLowerCase(); })) {
            return false;
        }
        coupons.value.push({ code: code, ghost: true });
        return true;
    }
    function removeCoupon(code) {
        if (!coupons.value.find(function (coupon) { return code === coupon.code; })) {
            return false;
        }
        coupons.value = coupons.value.filter(function (coupon) { return code !== coupon.code; });
        return true;
    }
    function setAvailable(available) {
        giftsAvailable.value = available;
        if (gifts.value.length > available) {
            gifts.value = gifts.value.slice(0, available);
        }
    }
    function setGifts(newGifts) {
        gifts.value = newGifts;
    }
    function setGiftableProducts(newGiftable) {
        giftable.value = newGiftable.sort(function (a, b) { return a.name.localeCompare(b.name); });
    }
    function addGift(productId) {
        var gift = giftable.value.find(function (gift) { return gift.productId === productId; });
        if (!gift) {
            return false;
        }
        gifts.value.push(gift);
        return true;
    }
    function removeGift(productId) {
        var newGifts = gifts.value.filter(function (gift) { return gift.productId !== productId; });
        if (newGifts.length === gifts.value.length) {
            return false;
        }
        gifts.value = newGifts;
        return true;
    }
    function setGiftLimits(minAmount, vipAmount) {
        giftsMinOrderSum.value = minAmount;
        giftsVipMinOrderSum.value = vipAmount;
    }
    return {
        initialized: initialized,
        // Gifts
        gifts: gifts,
        giftable: giftable,
        giftsAvailable: giftsAvailable,
        giftsUsed: giftsUsed,
        giftsLeft: giftsLeft,
        vipAvailable: vipAvailable,
        giftsMinOrderSum: giftsMinOrderSum,
        giftsVipMinOrderSum: giftsVipMinOrderSum,
        setAvailable: setAvailable,
        setGifts: setGifts,
        setGiftableProducts: setGiftableProducts,
        addGift: addGift,
        removeGift: removeGift,
        setGiftLimits: setGiftLimits,
        // Coupons
        coupons: coupons,
        setCoupons: setCoupons,
        addCoupon: addCoupon,
        removeCoupon: removeCoupon,
        // Products
        products: products,
        bottles: bottles,
        getProduct: getProduct,
        setProducts: setProducts,
        removeProduct: removeProduct,
        // Totals
        totalSum: totalSum,
        totalDiscount: totalDiscount,
        setTotals: setTotals,
    };
});
